
import { Component, Vue, Ref } from "vue-property-decorator"
import { CasesNotification } from "@/types"
import { Getter, Action, State } from "vuex-class"
import moment from "moment"
import { BDropdown } from "bootstrap-vue"
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { BaseState } from "@/store"
import { CurrentUser } from "@/types/user"

	@Component({
		components: {
			"scrollbar": VuePerfectScrollbar
		}
	})
export default class BaseNotificationsMenu extends Vue {
		@State((state: BaseState) => state.screenWidth)	private screenWidth!: number;
		@State((state: BaseState) => state.me) private me!: CurrentUser;

		@Getter("getNotifications") public currentNotifications!: CasesNotification[];
		@Getter("getBrowserNotificationsPermission") public browserNotificationsEnabled!: boolean;

		@Action requestBrowserNotificationsPermission!: () => void;
		@Action processNotification!: (notification: CasesNotification) => void;
		@Action clearAllNotifications!: () => void;

		@Ref() notificationsDropdown!: BDropdown;

		public notificationTimePeriods: string[] = [];

		/**
		 * Gets a human-readable version of the time elapsed since the notification was created
		 * Gives only the most significant time (e.g. seconds, minutes, hours & days)
		 * @param notification The notification to create the time elapsed message for
		 */
		public timeElapsedNotification (notification: CasesNotification): string {
			const notificationTime = new Date(moment(notification.created).format("l LTS"))
			const timeDifference = Date.now() - notificationTime.getTime()

			let days = Math.floor(timeDifference / (1000 * 60 * 60 * 24))
			let hours = Math.floor(Math.abs(timeDifference) / (1000 * 60 * 60) % 24)
			let minutes = Math.floor(Math.abs(timeDifference) / (1000 * 60) % 60)
			let seconds = Math.ceil(Math.abs(timeDifference) / (1000) % 60)

			let timeMessage = ""
			if (days === 1) {
				timeMessage = `${days} day`
			} else if (days > 1) {
				timeMessage = `${days} days`
			} else if (hours === 1) {
				timeMessage = `${hours} hour`
			} else if (hours > 1) {
				timeMessage = `${hours} hours`
			} else if (minutes === 1) {
				timeMessage = `${minutes} minute`
			} else if (minutes > 1) {
				timeMessage = `${minutes} minutes`
			} else if (seconds === 1) {
				timeMessage = `${seconds} second`
			} else if (seconds > 1) {
				timeMessage = `${seconds} seconds`
			} else {
				return "Just now"
			}

			return `${timeMessage} ago`
		}

		private notificationListOpened (): void {
			this.notificationTimePeriods = []
			let notifications: CasesNotification[] = this.currentNotifications
			notifications.forEach((notification) => {
				this.notificationTimePeriods.push(this.timeElapsedNotification(notification))
			})
		}

		private get browserNotificationsPermissionEnabled (): boolean {
			return this.browserNotificationsEnabled
		}

		private enableBrowserNotifications (): void {
			this.requestBrowserNotificationsPermission()
		}

		private notificationSelected (notification: CasesNotification): void {
			this.processNotification(notification)
			this.notificationsDropdown.hide(true)
		}

		private onClearAllNotifications (): void {
			this.clearAllNotifications()
			this.notificationsDropdown.hide(true)
		}
}
